import { Box, Card, CardBody, CardHeader, CheckBox, FormField, Heading, Markdown } from "grommet";
import { RangeInputWithSteps } from "../../forms/RangeInputWithSteps";
import { useTranslation } from "react-i18next";
import { useGetAuctionSettingsQuery, useUpdateAuctionSettingsMutation } from "../../api/userApi";
import { useSelector } from "react-redux";
import { authenticationSelector } from "../../slices/authSlice";
import { InfoSection } from "../layout/InfoSection";
import { AuctionSettingsTipsTranslation } from "../../md-translation/AuctionSettingsTipsTranslation";

export const AuctionSettings = () => {

    const { t, i18n } = useTranslation('settings');

    const isAuthenticated = useSelector(authenticationSelector);
    const { data: auctionSettings, isSuccess: isAuctionSettingsLoaded } = useGetAuctionSettingsQuery(undefined, { skip: !isAuthenticated });
    const [updateAuctionSettings] = useUpdateAuctionSettingsMutation();

    const steps = [
        { value: 0, label: 'manualModeTitle', description: 'manualModeDescription' },
        { value: 1, label: 'existingModeTitle', description: 'existingModeDescription' },
        { value: 2, label: 'fullAutoModeTitle', description: 'fullAutoModeDescription' },
    ];

    if (isAuctionSettingsLoaded) {
        return (
            <Card background="#222222" fill="vertical">
                <CardHeader pad={{ top: 'medium', left: 'medium', right: 'medium', bottom: 'none' }}>
                    <Heading margin={{ top: 'none', bottom: 'none' }} level={2} size="medium" weight={'bold'}>
                        {t('auctionSettings')}
                    </Heading>
                </CardHeader>
                <CardBody pad="medium" gap="medium">
                    <Box>
                        <CheckBox toggle label={t('appendUsernameLabel')} checked={auctionSettings?.appendUsername} onChange={(event) => updateAuctionSettings({ appendUsername: event.target.checked })} pad={'none'} />
                    </Box>
                    <Box direction="row" gap="medium">
                        <Box basis="50%">
                            <FormField label={t('newLotModeLabel')} noBorder noHover noFocus width={'100%'}>
                                <RangeInputWithSteps steps={steps} value={auctionSettings.addMode} onChange={(value) => updateAuctionSettings({ addMode: value })} labelKey={(label) => t(label)} descriptionKey={(description) => t(description)} margin={{ top: 'small' }} />
                            </FormField>
                        </Box>
                        <Box basis="50%">
                            <InfoSection>
                                <Box>
                                    <Markdown components={{ p: { props: { style: { maxWidth: '100%' } } }, img: { props: { style: { width: '100%' } } } }}>
                                        {AuctionSettingsTipsTranslation[i18n.language]}
                                    </Markdown>
                                </Box>
                            </InfoSection>
                        </Box>
                    </Box>
                </CardBody>
            </Card>
        )
    }
}